/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarketBarcodeResVo
 */
export interface MarketBarcodeResVo {
    /**
     * 主键ID
     * @type {number}
     * @memberof MarketBarcodeResVo
     */
    id?: number;
    /**
     * 条形码编号
     * @type {string}
     * @memberof MarketBarcodeResVo
     */
    marketBarcode?: string;
    /**
     * 条形码商品名称
     * @type {string}
     * @memberof MarketBarcodeResVo
     */
    marketProductName?: string;
    /**
     * 条形码选项名
     * @type {string}
     * @memberof MarketBarcodeResVo
     */
    marketOptionName?: string;
    /**
     * 条形码选项ID
     * @type {string}
     * @memberof MarketBarcodeResVo
     */
    marketOptionId?: string;
    /**
     * 第三方电商平台ID
     * @type {number}
     * @memberof MarketBarcodeResVo
     */
    businessPlatformId?: number;
    /**
     * 第三方电商平台名称（根据语言返回中韩文）
     * @type {string}
     * @memberof MarketBarcodeResVo
     */
    businessPlatformName?: string;
    /**
     * 是否可删除（条形码编号等于 SKU 编码时不可删）
     * @type {boolean}
     * @memberof MarketBarcodeResVo
     */
    deletable?: boolean;
    /**
     * 是否可编辑（条形码编号等于 SKU 编码时不可改）
     * @type {boolean}
     * @memberof MarketBarcodeResVo
     */
    editable?: boolean;
}

/**
 * Check if a given object implements the MarketBarcodeResVo interface.
 */
export function instanceOfMarketBarcodeResVo(value: object): value is MarketBarcodeResVo {
    return true;
}

export function MarketBarcodeResVoFromJSON(json: any): MarketBarcodeResVo {
    return MarketBarcodeResVoFromJSONTyped(json, false);
}

export function MarketBarcodeResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketBarcodeResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'businessPlatformName': json['businessPlatformName'] == null ? undefined : json['businessPlatformName'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'editable': json['editable'] == null ? undefined : json['editable'],
    };
}

export function MarketBarcodeResVoToJSON(json: any): MarketBarcodeResVo {
    return MarketBarcodeResVoToJSONTyped(json, false);
}

export function MarketBarcodeResVoToJSONTyped(value?: MarketBarcodeResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'businessPlatformId': value['businessPlatformId'],
        'businessPlatformName': value['businessPlatformName'],
        'deletable': value['deletable'],
        'editable': value['editable'],
    };
}

